import { LitElement } from 'lit';
export class IconLitElement extends LitElement {
    // reactive properties
    static get properties() {
        return {
            disabled: {
                type: Boolean
            },
            flipHorizontal: {
                attribute: 'flip-horizontal',
                type: Boolean
            },
            flipVertical: {
                attribute: 'flip-vertical',
                type: Boolean
            },
            icon: {
                type: String
            },
            iconColor: {
                attribute: 'icon-color',
                type: String
            },
            iconSize: {
                attribute: 'icon-size',
                type: String
            },
            useShadowDom: {
                attribute: 'use-shadow-dom',
                type: Boolean
            }
        };
    }
    get computedIconSize() {
        return this.iconSize.includes('px') ? this.iconSize : `${this.iconSize}px`;
    }
    connectedCallback() {
        super.connectedCallback();
        this.iconSize = this.iconSize || '18px';
    }
    createRenderRoot() {
        if (!this.useShadowDom) {
            return this;
        }
        return super.createRenderRoot();
    }
    constructor() {
        super();
        this.disabled = false;
        this.iconColor = '';
        this.useShadowDom = false;
        // We are using the light dom, we need to manually apply styles to the
        // document. We only want to do this one time, so we are using a boolean
        // flag to track it. Our version of typescript doesn't know about
        // adoptedStyleSheets or replaceSync, so we are asserting anys.
        if (!this.useShadowDom &&
            !document.adoptedStyleSheets.some((sheet) => sheet.__isIconComponentSheet)) {
            const sheet = new CSSStyleSheet();
            sheet.__isIconComponentSheet = true;
            sheet.replaceSync(this.getCssAsString());
            document.adoptedStyleSheets = [sheet, ...document.adoptedStyleSheets];
        }
    }
    getCssAsString() {
        const styles = this.constructor.styles;
        // Check if styles is an array
        if (Array.isArray(styles)) {
            // If it's an array, map over and extract `cssText` from each `CSSResult`
            return styles.map((style) => style.cssText).join(' ');
        }
        // If it's a single `CSSResult`, directly access `cssText`
        return styles.cssText;
    }
}
